<template>
    <section class="predictions-carousel">
        <div v-if="isLoading"
            class="predictions-carousel--skeleton"
        >
            <prediction-tile-skeleton v-for="index in Array.from({ length: 4})"
                :key="index"
                :is-large="false"
            />
        </div>

        <carousel v-if="!isLoading && predictionList.length"
            :navigationEnabled="true"
            navigation-next-label=""
            navigation-prev-label=""
            :paginationEnabled="false"
            :scrollPerPage="false"
            :spacePadding="24"
            :perPageCustom="[
                [320, 1],
                [400, 1.2],
                [575, 1.25],
                [768, 0.9],
                [900, 1.25],
                [1000, 1.5],
                [1250, 2.1],
                [1600, 2.75],
                [1800, 3.2]
            ]"
        >
            <slide v-for="prediction in predictionList"
                :key="prediction.id"
            >
                <prediction-tile :partnerId="partnerId"
                    :teamId="teamId"
                    :currencyId="currencyId"
                    :sportEventData="prediction"
                    :isCarouselSportEvent="true"
                />
            </slide>
        </carousel>
    </section>
</template>

<script>
// 3rd party
import {
    mapGetters,
} from 'vuex';

// Components
import predictionTile from '@webapp/modules/fan-engagement/components/predictor/prediction-tile/prediction-tile.vue';
import predictionTileSkeleton from '@webapp/modules/fan-engagement/components/predictor/prediction-tile/prediction-tile-skeleton.vue';
import {
    Carousel,
    Slide,
} from 'vue-carousel';

export default {
    name: 'predictions-carousel-v2',
    components: {
        predictionTile,
        predictionTileSkeleton,
        Carousel,
        Slide,
    },
    props: {
        partnerId: {
            type: String,
            default: '',
        },
        teamId: {
            type: String,
            default: '',
        },
        isLoading: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapGetters('partners', ['partnerById']),

        ...mapGetters('predictorSportEvents', ['currentCarouselSportEvents']),

        predictionList() {
            return this.currentCarouselSportEvents(this.partnerId);
        },

        partner() {
            return this.partnerById(this.partnerId);
        },

        currencyId() {
            return this.partner?.currencyId || '';
        },
    },
};
</script>

<style lang="scss" scoped>
.predictions-carousel {
    margin: 0 1rem;

    &--skeleton {
        padding: 0 35px;
        margin-top: 1rem;
        display: inline-flex;

        .wrapper {
            padding: 2rem 4rem;
            margin-right: 55px;
        }
    }
}
</style>